import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/frontlineQ";
import { useAppSelector } from "../../../store";
import { getPerformanceYearShort } from "../../../common/util/period";
import { BannerTile } from "../../../common/components/BannerTile/BannerTile";
import { getBannerTitleKey, getBannerSubtitleKey } from "../../../common/util/groupGrowthUtils";
import { QUALIFICATION_STATUS } from "../../../common/enums/incentive-enums";
import { IncomeData } from "../../../services/FrontlineQ/frontlineQAPI.types";
import "./FrontlineQBannerTile.scss";

type Props = {
  isLoading: boolean;
  isNewPerformanceYear?: boolean;
  incomeData: IncomeData;
};

export const FrontlineQBannerTile = ({ incomeData, isLoading, isNewPerformanceYear }: Props) => {
  const { t } = useTranslation("frontlineQ");
  const { selectedPeriod } = useAppSelector((state) => state.period);

  const performanceYear = getPerformanceYearShort(selectedPeriod);
  const titleKey = getBannerTitleKey(incomeData.Status, isNewPerformanceYear);
  const descriptionKey = getBannerSubtitleKey(incomeData.Status, isNewPerformanceYear);

  return (
    <div className="FrontlineQBannerTile">
      <BannerTile
        isLoading={isLoading}
        title={t(`bannerTile.${titleKey}`, defaultContent.bannerTile[titleKey], { performanceYear })}
        description={`${t(`bannerTile.${descriptionKey}`, defaultContent["bannerTile"][descriptionKey])}`}
        bonusAmountLabel={t("bannerTile.potentialEarnings", defaultContent.bannerTile.potentialEarnings, {
          performanceYear: performanceYear,
        })}
        shouldDisplayAmount={
          ![QUALIFICATION_STATUS.HELD, QUALIFICATION_STATUS.DENIED].includes(incomeData.Status) && !isNewPerformanceYear
        }
        bonusAmount={incomeData.PotentialPYEarnings}
      />
    </div>
  );
};
